export const environment = {
  production: false,
  testEnvironment: false,
  apiUrl: 'http://172.30.31.41:50074/api/client',
  reCaptchaOptions: {
    isEnabled: true,
    siteKey: '6LfrqYgqAAAAAJoqvlH9kRkH28EMo4M2e9FRt_G3',
  },
};
